import useAuthStore from "./stores/useAuthStore";
import commonSpinner from "./stores/spinnerStore";
import stringEx from "@/mixin/globals/functions/stringEx"
export default {
    install(Vue) {
        Vue.mixin(stringEx)
        Vue.mixin(useAuthStore)
        Vue.mixin(commonSpinner)
    }
}
